import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '&store/store';
import LandingHeader from '../../components/landingHeader/landingHeader.component';
import CollaborateComponent from '../../components/collaborate/collaborate.component';
import WhatWeDoComponent from '../../components/whatWeDo/whatWeDo.component';
import ThemesComponent from '../../components/themes/themes.component';
import { challengesActions } from '&features/challenges/challenges.slice';
import { useSelector } from 'react-redux';
import ChallengeTimelineComponent from '../../components/challengeTimeline/challengeTimeline.component';
import EligibilityComponent from '../../components/eligibility/eligibility.component';
import EvaluationCriteriaComponent from '../../components/evaluationCriteria/evaluationCriteria.component';
import PrizesComponent from '../../components/prizes/prizes.component';
import { CircularProgress } from '@mui/material';
import OfferingComponent from '../../components/offering/offering.component';

type ReduxProps = ConnectedProps<typeof connector>;

const HomeComponent = (props: ReduxProps) => {
	const { getChallenges } = props;
	const { challenges, loading } = useSelector(
		(state: RootState) => state.challenges
	);
	useEffect(() => {
		getChallenges();
	}, []);

	return (
		<>
			<LandingHeader />
			<CollaborateComponent />
			<WhatWeDoComponent />
			<ThemesComponent />
			{loading ? (
				<div className="loading-center">
					<CircularProgress size={40} color="inherit" />
				</div>
			) : (
				<>
					<OfferingComponent offering={challenges.current[0]?.offering} />
					<ChallengeTimelineComponent
						timeLine={challenges.current[0]?.timeline}
					/>
					<EligibilityComponent challenge={challenges.current[0]} />
					<EvaluationCriteriaComponent
						criteria={challenges.current[0]?.evaluationCriteria}
					/>
					<PrizesComponent prizes={challenges.current[0]?.prizes} />
				</>
			)}
		</>
	);
};

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = {
	getChallenges: challengesActions.getChallenges,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const HomeComponentRedux = connector(HomeComponent);

export { HomeComponentRedux as HomeComponent };
